import $ from 'jquery';

import TastypieCollection from 'screener/collections/tastypie';
import UserProgress from 'screener/models/user_progress';
import DateNav from 'core/controllers/date_navigation';


export default TastypieCollection.extend({
  model: UserProgress,
  comparator: 'completed_at',
  urlRoot: USERPROGRESS_API_URL
});


/* Screener results of a user

An example GET request might look like this

    http://moodhackerapp.orcasdemo.com/screener/api/v3/screener/userprogress/?screener_set_item__screener__slug=workplace-wellness&oauth_consumer_key=<oauth_consumer_key>&format=json

    Response:
    {
      "meta": {
        "limit": 1000,
        "next": null,
        "offset": 0,
        "previous": null,
        "total_count": 1
      },
      "objects": [{
        "completed_at": "2014/07/28",
        "feedbacks": [{
          "content": "\t<p>Your well-being at work doesn&#8217;t only affect your career path&#8212;it can also affect workplace safety. Minimize mood-related occupational hazards by tracking your mood and activities often. Try things like finding activities to lessen workplace stress and journaling about specific on-the-job situations can help you discover what activities help you get to a better place. </p>\n\n\t<p>To find out more, contact your <span class=\"caps\">EAP</span>.</p>",
          "feedback_type": "score",
          "media_items": [],
          "plan_text": "\t<p>Keep work-related stress in check by making positive activities a part of your workday routine. Call your Employee Assistance Program for additional guidance.</p>"
        }],
        "id": 1,
        "last_question_log": "/screener/api/v1/log/question/5/",
        "options": [],
        "percentage_complete": "0.83",
        "resource_uri": "/screener/api/v1/screener/userprogress/1/",
        "score": 0,
        "screener_set_item": "/screener/api/v1/screener/screenersetitem/8/",
        "screener_set_item__screener__name": "Workplace Wellness",
        "started_at": "2014-07-28T16:02:10.187311"
      }]
    }

    You may also use a completed_at__gte parameter to specify a minimum completed date in the format "YYYY-MM-DD"

    NOTE: This API does not return all screener results, only the result of the last screener taken for each screener.
*/



//////////////////
// WEBPACK FOOTER
// ./node_modules/screener-app/screener/static/js/screener/collections/user_progress.js
// module id = 73
// module chunks = 0